import styled from "styled-components";

export const StyledSocialIconsDiv = styled.div`
  .social-icons {
    transition: background-color 0.2s;
    color: #fff;
  }

  .social-icon {
    font-size: 20px;
  }

  :hover {
    background: #fff;
  }

  .social-icons:hover .social-icon {
    color: ${(props) => props.primarycolor};
  }
`;

export const StyledFooterIconsDiv = styled.div`
  .social-icons {
    transition: background-color 0.2s;
    color: ${(props) => props.primarycolor};
  }

  .social-icon {
    font-size: 20px;
  }

  :hover {
    background: ${(props) => props.primarycolor};
  }

  .social-icons:hover .social-icon {
    color: #fff;
  }
`;
